import React from 'react';
import { Snackbar, Alert } from '@mui/material';

export interface NotificationMessage {
  id: string;
  message: string;
  severity: 'success' | 'error' | 'warning' | 'info';
}

interface NotificationSnackbarProps {
  notifications: NotificationMessage[];
  onClose: (id: string) => void;
}

const NotificationSnackbar: React.FC<NotificationSnackbarProps> = ({ notifications, onClose }) => (
  <>
    {notifications.map(({ id, message, severity }) => (
      <Snackbar
        key={id}
        open
        autoHideDuration={4000}
        onClose={() => onClose(id)}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        sx={{
          '& .MuiSnackbar-root': {
            top: { xs: 16, sm: 24 },
          },
        }}
      >
        <Alert
          onClose={() => onClose(id)}
          severity={severity}
          sx={{
            width: 'auto',
            minWidth: 'fit-content',
            maxWidth: { xs: 'calc(100vw - 32px)', sm: '90vw' },
            mx: 'auto',
            boxShadow: 3,
            wordBreak: 'break-word',
          }}
        >
          {message}
        </Alert>
      </Snackbar>
    ))}
  </>
);

export default NotificationSnackbar;
